// react
import React from 'react'

import AudienceCreator, { AC_PAGE_TYPES } from '../../audience-creator'

// NOTE: proxy component, audience creator page will power up taxonomies
const TaxonomyAudience = (props) => {
  return <AudienceCreator pageType={AC_PAGE_TYPES.TX} match={props.match} />
}

export default TaxonomyAudience
